export const isNullOrUndefined = (value) => {
  return value === null || value === undefined;
};

export const isNullOrEmpty = (value) => {
  return isNullOrUndefined(value) || value.length === 0;
};


export const isNumberValid = (value) => {
  return !(isNullOrUndefined(value) || Number.isNaN(value));
};

export const valorString = (value) => {
  return isNullOrUndefined(value) ? '' : value;
};


export const extractPartOfStringByDelimiter = (value: string, delimiter: string, position: number) => {
  return value.split(delimiter)[position];
};

export const extractStringByDelimiter = (value: string, delimiter: string) => {

    if (['PS', 'PR'].includes(value.split(delimiter)[0])) {
      const underscoreIndex = value.lastIndexOf(delimiter);
      return [value.substring(0, underscoreIndex), value.substring(underscoreIndex + 1)];
    }

    return value.split(delimiter);
  }
;

export const convertArrayToString = (array: any[]) => {
  let val = '';
  array.forEach((value, index) => {
    val = val.concat(value);
    val = index !== (array.length - 1) ? val.concat(',') : val;
  });
  return val;
};


export const findWithAttr = (array: any[], attr: string, value) => {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
};

export const isEmptyObj = (obj) => {
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }
  return true;
};

export const groupBy = (array: any[], callbackGroup: (item, acc) => string, callbackTransform: (acc, item) => {}) => {
  const novo = array.reduce((acc, item) => {
    const key = callbackGroup(item, acc);
    acc[key] = acc[key] || [];
    acc[key] = callbackTransform(acc[key], item);
    return acc;
  }, {});
  return Object.keys(novo).map(key => novo[key]);
};


export const flat = (array: any[]) => {
  return array.reduce((acc, val) => acc.concat(val), []);
};

export const compararArrays = (r1: any[], r2: any[]): Boolean => {
  return (r1 && r2) && (`${r1}` === `${r2}`);
};

export const toQuery = (params, delimiter = '&') => {
  const keys = Object.keys(params);
  return keys.reduce((str, key, index) => {
    let query = `${str}${key}=${params[key]}`;

    if (index < (keys.length - 1)) {
      query += delimiter;
    }

    return query;
  }, '');
};

export const verificarQtdCaracteres = (valor, qtdMaxima) => {
  return valor.toString().length > qtdMaxima;
};

export const removeDuplicatesByProperty = (arr: any[], prop: keyof any) => {

  const uniqueMap = new Map<any, any>();
  const duplicatesMap = new Map<any, any>();

  arr.forEach((obj) => {
    if (!uniqueMap.has(obj[prop])) {
      uniqueMap.set(obj[prop], obj);
    } else if (obj.hasOwnProperty('original')) {
      duplicatesMap.set(obj[prop], obj);
      uniqueMap.set(obj[prop], obj);
    }
  });
  return Array.from(uniqueMap.values());
};

export const isValidoHorarioString = (horario: string) => {
  const regexHora = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
  return regexHora.test(horario);
};


export const   removerObjetoDuplicadoInArrayByProp = (arr: any[], property: keyof any): any[] => {
  const uniqueItems: any[] = [];
  const idSet: Record<number, boolean> = {};

  for (const item of arr) {
    const id = item[property];
    if (!idSet[id]) {
      idSet[id] = true;
      uniqueItems.push(item);
    }
  }

  return uniqueItems;
};

export const mapPropiedadeFromObjeto = (obj: any, prop: any) => {
  return [...new Set(obj.map(p => p[prop]).filter(propriedade => propriedade != null))];
};


export const sleep = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const getPrefixPonto = (value: string) => {
  if (value[0] === 'PS') {
    return 'Ponto de Passagem ' + value[1];
  } else if (value[0] === 'PR') {
    return 'Ponto de Parada ' + value[1];
  } else {
    return 'Cliente ' + value[0];
  }
};

export const ifExistListAndIsEmptyListNull = (list: any[]) => {
  return list && list.length > 0 ? list : null;
};

export const ifValueNullZeroString = (value: any) => {
  return value === null ? '0' : value;
};

export const calcularDistanciaEntreCoresDeltaE = (
  rgbA: [number, number, number],
  rgbB: [number, number, number]
) => {
  let labA = rgb2lab(rgbA);
  let labB = rgb2lab(rgbB);
  let deltaL = labA[0] - labB[0];
  let deltaA = labA[1] - labB[1];
  let deltaB = labA[2] - labB[2];
  let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
  let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
  let deltaC = c1 - c2;
  let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
  deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
  let sc = 1.0 + 0.045 * c1;
  let sh = 1.0 + 0.015 * c1;
  let deltaLKlsl = deltaL / 1.0;
  let deltaCkcsc = deltaC / sc;
  let deltaHkhsh = deltaH / sh;
  let i =
    deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
  return i < 0 ? 0 : Math.sqrt(i);
}

export const rgb2lab = (rgb: [number, number, number]): [number, number, number] => {
  let r = rgb[0] / 255,
    g = rgb[1] / 255,
    b = rgb[2] / 255,
    x,
    y,
    z;
  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
  b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
  x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
  y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
  z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
}

/**
 * Para bindings [ngClass] calculados por função: retorna o array anterior quando as classes são as mesmas.
 * O NgClass do Angular 8 remove e recoloca todas as classes sempre que recebe uma nova referência,
 * o que invalida o estilo do elemento e de todos os descendentes a cada change detection.
 */
export function manterReferenciaClasses(anteriores: string[], novas: string[]): string[] {
  if (anteriores && anteriores.length === novas.length && anteriores.every((classe, i) => classe === novas[i])) {
    return anteriores;
  }
  return novas;
}
